import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEquals } from '@fortawesome/free-solid-svg-icons';

/**
 * The figure a step produced, EMPHASISED or not.
 *
 * Both regimes' popovers hang off several columns, and the reader was sent by
 * exactly one of them. The step that answers THAT column is set apart; the
 * intermediate ones are not. The two class strings below are the whole
 * vocabulary, and they lived open-coded at six call sites before this — which
 * is how UK ended up with a liability that was permanently emphasised whichever
 * column opened the popover, and no way to emphasise anything else.
 */
export const BREAKDOWN_RESULT_HIGHLIGHT = 'text-orange-600 font-semibold';
export const BREAKDOWN_RESULT_PLAIN = 'text-purple-700';

/**
 * The right-hand side of a step: an equals sign and the figure it produces.
 *
 * Both halves travel together because every derivation in the app writes them
 * together, and the colour of the equals sign is the only thing that varies.
 *
 * @param {Object} props
 * @param {boolean} [props.highlighted] - whether this is the figure the reader
 *   was sent here for. `className` wins where a caller passes one, so every
 *   existing call site renders exactly what it rendered before (I1).
 * @param {string} [props.className] - the figure's classes; the highlight is
 *   the consumer's call (a result the reader was sent here for is emphasised,
 *   an intermediate one is not)
 * @param {string} [props.equalsClassName]
 * @param {React.ReactNode} props.children - the figure
 */
export default function CgBreakdownResult({
  highlighted = false,
  className,
  equalsClassName = 'mx-1 text-gray-400',
  children,
}) {
  const figureClassName =
    className ?? (highlighted ? BREAKDOWN_RESULT_HIGHLIGHT : BREAKDOWN_RESULT_PLAIN);

  return (
    <>
      <FontAwesomeIcon
        icon={faEquals}
        className={equalsClassName}
      />
      <span className={figureClassName}>{children}</span>
    </>
  );
}
